import { post } from '../base';

export default function useNewsletterSubscribe() {
  return (values) => post('/newsletter/subscribe', values);
}
